import type { UserGroupRecordListPartner } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useMemo } from 'react';

export const useImpersonationUserGroups = ({
  userIds,
  serviceDepartmentIds
}: {
  userIds: number[];
  serviceDepartmentIds?: number[];
}) => {
  const query = noddiAsync.useGet({
    type: URLKeys.getPaginatedUserGroupsIgnoringImpersonation,
    input: { userIds, serviceDepartmentIds },
    queryConfig: { enabled: userIds.length > 0 }
  });
  const groupsByUserId = useMemo(() => {
    const result = new Map<number, UserGroupRecordListPartner[]>();
    for (const group of query.data?.results ?? []) {
      for (const user of group.users) {
        result.set(user.id, [...(result.get(user.id) ?? []), group]);
      }
    }
    return result;
  }, [query.data]);

  return { ...query, groupsByUserId };
};
